<div class="profile-multi-select" [class.is-disabled]="disabled">
  <div
    class="custom-multi-select"
    dropdown
    #multiDropdown="bs-dropdown"
    #multiDropdownContainer
    [autoClose]="true"
    [insideClick]="true"
    placement="bottom left"
    container="body"
  >
    <!-- Header -->
    <div class="select-display" dropdownToggle [class.is-disabled]="disabled">
      <div class="left">
        <i class="fas fa-search fa-lg icon-search"></i>

        <div class="tags-selected" #tagsSelected>
          <div *ngFor="let id of value" class="item-selected">
            <h4 class="mr-2 item-text">{{ nameById(id) }}</h4>
            <i
              *ngIf="!isLocked(id)"
              class="fas fa-xmark cursor-pointer"
              (click)="remove(id); $event.stopPropagation()"
              aria-label="Remover"
            ></i>
          </div>

          <span *ngIf="!value.length" class="placeholder">
            {{ placeholder }}
          </span>
        </div>
      </div>

      <div class="right">
        <span *ngIf="countPlus > 0" class="count-plus-label">+ {{ countPlus }}</span>
        <i class="fas fa-chevron-down caret"></i>
      </div>
    </div>

    <!-- Menu -->
    <ul
      *dropdownMenu
      class="dropdown-menu w-100 p-2 profile-ms__menu"
      role="menu"
      (click)="$event.stopPropagation()"
      [style.width.px]="dropdownWidth"
      [style.minWidth.px]="dropdownWidth"
    >
      <li *ngFor="let p of filtered" role="menuitem">
        <button
          type="button"
          class="dropdown-item profile-ms__item"
          (click)="toggle(p.id); $event.stopPropagation()"
          [disabled]="disabled || isLocked(p.id)"
          [title]="isLocked(p.id) ? 'Apenas o Proprietário pode atribuir este perfil' : ''"
        >
          <div class="profile-ms__item-left">
            <span class="profile-ms__name text-truncate">{{ p.name }}</span>
            <span *ngIf="p.isSystem" class="badge bg-light text-secondary ms-2">Sistema</span>
          </div>

          <i *ngIf="isChecked(p.id)" class="fas fa-check profile-ms__check"></i>
        </button>
      </li>

      <li *ngIf="!filtered.length" class="px-3 py-2 profile-ms__empty">
        Nenhum perfil encontrado.
      </li>
    </ul>
  </div>
</div>